import React, { Component } from 'react';
import styles from './cutText.css';
import { Scrollbars } from 'react-custom-scrollbars';
import InfoIcon from 'assets/svg/info.svg';
import { resizeListener, wrapUrlByTag } from '../../utils/func';


class CutText extends Component {

    constructor( props ) {
        super( props );

        this.state = {
            cutText: '',
            text: '',
            limit: false,
            showText: false,
            fSize: '3rem',
            type: 'default'
        };
        this.resizeElm = null;
        this.elmP = null;

        this.sizeCoef = [
            {
                format: 0,
                aCoff: [ { ew: 200, k: 0.7 }, { ew: 400, k: 0.8 }, { ew: 600, k: 0.8 }, { ew: 800, k: 0.4 }, {
                    ew: 1000,
                    k: 0.4
                }, { ew: 1200, k: 0.4 }, { ew: 1400, k: 2 }, { ew: 1600, k: 0.4 }, { ew: 1800, k: 0.4 }, {
                    ew: 1900,
                    k: 0.4
                }, { ew: 2900, k: 0.4 } ]
            },
            {
                format: 20,
                aCoff: [ { ew: 200, k: 0.4 }, { ew: 400, k: 0.4 }, { ew: 600, k: 0.4 }, { ew: 800, k: 0.4 }, {
                    ew: 1000,
                    k: 0.4
                }, { ew: 1200, k: 0.4 }, { ew: 1400, k: 0.4 }, { ew: 1600, k: 0.4 }, { ew: 1800, k: 0.4 }, {
                    ew: 1900,
                    k: 0.4
                }, { ew: 2900, k: 0.4 } ]
            },
            {
                format: 40,
                aCoff: [ { ew: 200, k: 0.35 }, { ew: 400, k: 0.35 }, { ew: 600, k: 0.32 }, { ew: 800, k: 0.32 }, {
                    ew: 1000,
                    k: 0.4
                }, { ew: 1200, k: 0.4 }, { ew: 1400, k: 0.4 }, { ew: 1600, k: 0.4 }, { ew: 1800, k: 0.4 }, {
                    ew: 1900,
                    k: 0.4
                }, { ew: 2900, k: 0.4 } ]
            },
            {
                format: 60,
                aCoff: [ { ew: 200, k: 0.4 }, { ew: 400, k: 0.4 }, { ew: 600, k: 0.5 }, { ew: 800, k: 0.5 }, {
                    ew: 1000,
                    k: 0.5
                }, { ew: 1200, k: 0.5 }, { ew: 1400, k: 0.5 }, { ew: 1600, k: 0.5 }, { ew: 1800, k: 0.5 }, {
                    ew: 1900,
                    k: 0.5
                }, { ew: 2900, k: 0.5 } ]
            },
            {
                format: 80,
                aCoff: [ { ew: 200, k: 0.4 }, { ew: 400, k: 0.4 }, { ew: 600, k: 0.4 }, { ew: 800, k: 0.4 }, {
                    ew: 1000,
                    k: 0.4
                }, { ew: 1200, k: 0.4 }, { ew: 1400, k: 0.4 }, { ew: 1600, k: 0.4 }, { ew: 1800, k: 0.4 }, {
                    ew: 1900,
                    k: 0.4
                }, { ew: 2900, k: 0.4 } ]
            },
            {
                format: 100,
                aCoff: [ { ew: 200, k: 0.55 }, { ew: 400, k: 0.55 }, { ew: 600, k: 0.55 }, { ew: 800, k: 0.55 }, {
                    ew: 1000,
                    k: 0.8
                }, { ew: 1200, k: 0.8 }, { ew: 1400, k: 0.8 }, { ew: 1600, k: 0.8 }, { ew: 1800, k: 0.8 }, {
                    ew: 1900,
                    k: 0.8
                }, { ew: 2900, k: 0.8 } ]
            },
            {
                format: 120,
                aCoff: [ { ew: 200, k: 0.3 }, { ew: 400, k: 0.3 }, { ew: 600, k: 0.3 }, { ew: 800, k: 0.3 }, {
                    ew: 1000,
                    k: 0.4
                }, { ew: 1200, k: 0.4 }, { ew: 1400, k: 0.4 }, { ew: 1600, k: 0.4 }, { ew: 1800, k: 0.4 }, {
                    ew: 1900,
                    k: 0.4
                }, { ew: 2900, k: 0.4 } ]
            },
            {
                format: 130,
                aCoff: [ { ew: 200, k: 0.3 }, { ew: 400, k: 0.3 }, { ew: 600, k: 0.3 }, { ew: 800, k: 0.3 }, {
                    ew: 1000,
                    k: 0.4
                }, { ew: 1200, k: 0.4 }, { ew: 1400, k: 0.4 }, { ew: 1600, k: 0.4 }, { ew: 1800, k: 0.4 }, {
                    ew: 1900,
                    k: 0.4
                }, { ew: 2900, k: 0.4 } ]
            },
        ];

        this.tetxFontArr1 = [
            {
                format: 0,
                fArr: [ { ew: 200, f: '1.3rem' }, { ew: 400, f: '1.3rem' }, { ew: 600, f: '1.3rem' }, {
                    ew: 800,
                    f: '1.3rem'
                }, { ew: 1000, f: '1.3rem' }, { ew: 1200, f: '1.3rem' }, { ew: 1400, f: '1.3rem' }, {
                    ew: 1600,
                    f: '1.3rem'
                }, { ew: 1800, f: '1.3rem' }, { ew: 1900, f: '1.3rem' }, { ew: 2900, f: '1.3rem' } ]
            },
            {
                format: 20,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '2.5rem' }, { ew: 1200, f: '2.5rem' }, { ew: 1400, f: '2.2rem' }, {
                    ew: 1600,
                    f: '2rem'
                }, { ew: 1800, f: '2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 40,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '2.5rem' }, { ew: 1200, f: '2.2rem' }, { ew: 1400, f: '2rem' }, {
                    ew: 1600,
                    f: '2rem'
                }, { ew: 1800, f: '2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 60,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '3rem' }, { ew: 1200, f: '2.2rem' }, { ew: 1400, f: '2.2rem' }, {
                    ew: 1600,
                    f: '2.2rem'
                }, { ew: 1800, f: '2rem' }, { ew: 1900, f: '2.5rem' }, { ew: 2900, f: '2.5rem' } ]
            },
            {
                format: 80,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '5rem' }, { ew: 600, f: '4.5rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '3.5rem' }, { ew: 1200, f: '3.2rem' }, { ew: 1400, f: '3.2rem' }, {
                    ew: 1600,
                    f: '3.2rem'
                }, { ew: 1800, f: '3.2rem' }, { ew: 1900, f: '3rem' }, { ew: 2900, f: '3rem' } ]
            },
            {
                format: 100,
                fArr: [ { ew: 200, f: '2.3rem' }, { ew: 400, f: '2.3rem' }, { ew: 600, f: '2.3rem' }, {
                    ew: 800,
                    f: '2.3rem'
                }, { ew: 1000, f: '1.9rem' }, { ew: 1200, f: '1.9rem' }, { ew: 1400, f: '1.9rem' }, {
                    ew: 1600,
                    f: '1.9rem'
                }, { ew: 1800, f: '1.9rem' }, { ew: 1900, f: '1.9rem' }, { ew: 2900, f: '1.9rem' } ]
            },
            {
                format: 120,
                fArr: [ { ew: 200, f: '4rem' }, { ew: 400, f: '4rem' }, { ew: 600, f: '4rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '4rem' }, { ew: 1200, f: '3.5rem' }, { ew: 1400, f: '3rem' }, {
                    ew: 1600,
                    f: '3rem'
                }, { ew: 1800, f: '3rem' }, { ew: 1900, f: '3rem' }, { ew: 2900, f: '3rem' } ]
            },
            {
                format: 130,
                fArr: [ { ew: 200, f: '3.5rem' }, { ew: 400, f: '3.5rem' }, { ew: 600, f: '4rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '4rem' }, { ew: 1200, f: '3.5rem' }, { ew: 1400, f: '3rem' }, {
                    ew: 1600,
                    f: '3rem'
                }, { ew: 1800, f: '3rem' }, { ew: 1900, f: '3rem' }, { ew: 2900, f: '3rem' } ]
            },
        ];


        this.tetxFontArr2 = [
            {
                format: 0,
                fArr: [ { ew: 200, f: '1.3rem' }, { ew: 400, f: '1.3rem' }, { ew: 600, f: '1.3rem' }, {
                    ew: 800,
                    f: '1.3rem'
                }, { ew: 1000, f: '1.3rem' }, { ew: 1200, f: '1.3rem' }, { ew: 1400, f: '1.3rem' }, {
                    ew: 1600,
                    f: '1.3rem'
                }, { ew: 1800, f: '1.3rem' }, { ew: 1900, f: '1.3rem' }, { ew: 2900, f: '1.3rem' } ]
            },
            {
                format: 20,
                fArr: [ { ew: 200, f: '5.5rem' }, { ew: 400, f: '5.5rem' }, { ew: 600, f: '5rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '4rem' }, { ew: 1200, f: '4rem' }, { ew: 1400, f: '4rem' }, {
                    ew: 1600,
                    f: '4rem'
                }, { ew: 1800, f: '4rem' }, { ew: 1900, f: '4rem' }, { ew: 2900, f: '4rem' } ]
            },
            {
                format: 40,
                fArr: [ { ew: 200, f: '4.5rem' }, { ew: 400, f: '4.5rem' }, { ew: 600, f: '4rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '4rem' }, { ew: 1200, f: '4rem' }, { ew: 1400, f: '4rem' }, {
                    ew: 1600,
                    f: '4rem'
                }, { ew: 1800, f: '4rem' }, { ew: 1900, f: '4rem' }, { ew: 2900, f: '4rem' } ]
            },
            {
                format: 60,
                fArr: [ { ew: 200, f: '6rem' }, { ew: 400, f: '6rem' }, { ew: 600, f: '6rem' }, {
                    ew: 800,
                    f: '6rem'
                }, { ew: 1000, f: '5.5rem' }, { ew: 1200, f: '5.5rem' }, { ew: 1400, f: '5.5rem' }, {
                    ew: 1600,
                    f: '5rem'
                }, { ew: 1800, f: '5rem' }, { ew: 1900, f: '5rem' }, { ew: 2900, f: '5rem' } ]
            },
            {
                format: 80,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '5rem' }, { ew: 600, f: '4.5rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '3.5rem' }, { ew: 1200, f: '3.2rem' }, { ew: 1400, f: '3.2rem' }, {
                    ew: 1600,
                    f: '3.2rem'
                }, { ew: 1800, f: '3.2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 100,
                fArr: [ { ew: 200, f: '2.3rem' }, { ew: 400, f: '2.3rem' }, { ew: 600, f: '2.3rem' }, {
                    ew: 800,
                    f: '2.3rem'
                }, { ew: 1000, f: '1.9rem' }, { ew: 1200, f: '1.9rem' }, { ew: 1400, f: '1.9rem' }, {
                    ew: 1600,
                    f: '1.9rem'
                }, { ew: 1800, f: '1.9rem' }, { ew: 1900, f: '1.9rem' }, { ew: 2900, f: '1.9rem' } ]
            },
            {
                format: 120,
                fArr: [ { ew: 200, f: '5rem' }, { ew: 400, f: '4.5rem' }, { ew: 600, f: '4.5rem' }, {
                    ew: 800,
                    f: '4.5rem'
                }, { ew: 1000, f: '4.5rem' }, { ew: 1200, f: '4rem' }, { ew: 1400, f: '4rem' }, {
                    ew: 1600,
                    f: '4rem'
                }, { ew: 1800, f: '4rem' }, { ew: 1900, f: '4rem' }, { ew: 2900, f: '4rem' } ]
            },
            {
                format: 130,
                fArr: [ { ew: 200, f: '5rem' }, { ew: 400, f: '4.5rem' }, { ew: 600, f: '4.5rem' }, {
                    ew: 800,
                    f: '4.5rem'
                }, { ew: 1000, f: '4.5rem' }, { ew: 1200, f: '4rem' }, { ew: 1400, f: '4rem' }, {
                    ew: 1600,
                    f: '4rem'
                }, { ew: 1800, f: '4rem' }, { ew: 1900, f: '4rem' }, { ew: 2900, f: '4rem' } ]
            },
        ];


        this.popupFontArr = [
            {
                format: 0,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '1.8rem' }, { ew: 600, f: '1.8rem' }, {
                    ew: 800,
                    f: '2rem'
                }, { ew: 1000, f: '2rem' }, { ew: 1200, f: '2rem' }, { ew: 1400, f: '2rem' }, {
                    ew: 1600,
                    f: '2rem'
                }, { ew: 1800, f: '2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 20,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '1.8rem' }, { ew: 600, f: '1.8rem' }, {
                    ew: 800,
                    f: '2rem'
                }, { ew: 1000, f: '2rem' }, { ew: 1200, f: '2rem' }, { ew: 1400, f: '2rem' }, {
                    ew: 1600,
                    f: '2rem'
                }, { ew: 1800, f: '2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 40,
                fArr: [ { ew: 200, f: '1.8rem' }, { ew: 400, f: '2rem' }, { ew: 600, f: '2rem' }, {
                    ew: 800,
                    f: '2rem'
                }, { ew: 1000, f: '2.2rem' }, { ew: 1200, f: '2.2rem' }, { ew: 1400, f: '2.2rem' }, {
                    ew: 1600,
                    f: '2.2rem'
                }, { ew: 1800, f: '2.2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 60,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '2rem' }, { ew: 1200, f: '2rem' }, { ew: 1400, f: '2rem' }, {
                    ew: 1600,
                    f: '2rem'
                }, { ew: 1800, f: '2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 80,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '5rem' }, { ew: 600, f: '4.5rem' }, {
                    ew: 800,
                    f: '4rem'
                }, { ew: 1000, f: '3.5rem' }, { ew: 1200, f: '3.2rem' }, { ew: 1400, f: '3.2rem' }, {
                    ew: 1600,
                    f: '3.2rem'
                }, { ew: 1800, f: '3.2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 100,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '3.5rem' }, { ew: 1200, f: '3.2rem' }, { ew: 1400, f: '3.2rem' }, {
                    ew: 1600,
                    f: '3.2rem'
                }, { ew: 1800, f: '3.2rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 120,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '3rem' }, { ew: 1200, f: '3rem' }, { ew: 1400, f: '3rem' }, {
                    ew: 1600,
                    f: '3rem'
                }, { ew: 1800, f: '3rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
            {
                format: 130,
                fArr: [ { ew: 200, f: '3rem' }, { ew: 400, f: '3rem' }, { ew: 600, f: '3rem' }, {
                    ew: 800,
                    f: '3rem'
                }, { ew: 1000, f: '3rem' }, { ew: 1200, f: '3rem' }, { ew: 1400, f: '3rem' }, {
                    ew: 1600,
                    f: '3rem'
                }, { ew: 1800, f: '3rem' }, { ew: 1900, f: '2rem' }, { ew: 2900, f: '2rem' } ]
            },
        ];

    };

    componentDidMount() {
        resizeListener( this.resizeElm, this.onResize );
        let type;

        switch ( this.props.type ) {
            case 'calendar': {
                type = 'calendar';
                break;
            }

            case 'quiz': {
                type = 'quiz';
                break;
            }

            default: {
                type = 'default';
            }

        }


        this.setState( { type: type }, () => {
            if ( ( this.props.text !== '' ) || ( this.props.text !== null ) ) {
                this.setText( this.props );
            }
        } );

    };

    componentDidUpdate( prewProps ) {
        if ( prewProps.text !== this.props.text ) {
            if ( ( this.props.text !== '' ) || ( this.props.text !== null ) ) {
                this.setText( this.props );
            }
        }
    };


    getAcoff = () => {
        try {
            let clientSize = this.elmP.getBoundingClientRect();
            let elmWidth = Number( clientSize.width );

            for ( let i = 0 ; i < this.sizeCoef.length ; i++ ) {
                if ( this.sizeCoef[ i ].format === this.props.format ) {
                    let aCoff = this.sizeCoef[ i ].aCoff;
                    for ( let v = aCoff.length - 1 ; v >= 0 ; v-- ) {
                        if ( aCoff[ v ].ew <= elmWidth ) {
                            return aCoff[ v ].k;
                        }
                    }
                    break;
                }

            }
        }catch ( e ){
            console.warn(e);
        }
    };


    getFont = () => {
        let elmWidth = window.innerWidth;
        for ( let i = 0 ; i < this.tetxFontArr1.length ; i++ ) {
            if ( this.tetxFontArr1[ i ].format === this.props.format ) {
                let fArr = this.tetxFontArr1[ i ].fArr;
                for ( let v = fArr.length - 1 ; v >= 0 ; v-- ) {
                    if ( fArr[ v ].ew <= elmWidth ) {
                        return fArr[ v ].f;
                    }

                }

                break;
            }

        }

    };


    getFont2 = () => {
        let elmWidth = window.innerWidth;
        for ( let i = 0 ; i < this.tetxFontArr2.length ; i++ ) {
            if ( this.tetxFontArr2[ i ].format === this.props.format ) {
                let fArr = this.tetxFontArr2[ i ].fArr;
                for ( let v = fArr.length - 1 ; v >= 0 ; v-- ) {
                    if ( fArr[ v ].ew <= elmWidth ) {
                        return fArr[ v ].f;
                    }
                }
                break;
            }
        }
    };

    getFontPopup = () => {
        let elmWidth = window.innerWidth;
        for ( let i = 0 ; i < this.popupFontArr.length ; i++ ) {
            if ( this.popupFontArr[ i ].format === this.props.format ) {
                let fArr = this.popupFontArr[ i ].fArr;
                for ( let v = fArr.length - 1 ; v >= 0 ; v-- ) {
                    if ( fArr[ v ].ew <= elmWidth ) {
                        return fArr[ v ].f;
                    }

                }

                break;
            }

        }

    };


    getFontSize = ( istext, text ) => {
        let fontSize;
        let textLength = typeof text === 'string' ? text.length : 0;

        if ( istext ) {
            if ( textLength > 25 ) {
                fontSize = this.getFont();
            } else {
                fontSize = this.getFont2();
            }
        } else {
            fontSize = this.getFontPopup();
        }
        return fontSize;
    };

    setText = ( tprops ) => {
        try {
            const { text, fontFam, lineCount } = tprops;
            let textLength = typeof text === 'string' ? text.length : 0;
            let cutText, twoElmWidth;
            let fontSize = this.getFontSize( true, text );
            let clientSize = this.elmP.getBoundingClientRect();
            let elmWidth = Number( clientSize.width );
            let kKoff = this.getAcoff();

            twoElmWidth = elmWidth * lineCount * kKoff;

            let lenPie = 0;
            let cutPie = 0;

            for ( let i = 0 ; i < textLength ; i++ ) {
                lenPie = lenPie + this.getWidthOfText( text[ i ], fontSize + fontFam );

                if ( lenPie >= twoElmWidth ) {
                    cutPie = i;
                    cutText = text.substr( 0, cutPie );

                    this.setState( {
                        text: text,
                        cutText: cutText,
                        limit: true,
                        fSize: this.getFontSize( true, text ),
                        ppfSize: this.getFontSize( false, text )
                    } );

                    break;
                } else {
                    this.setState( {
                        text: text,
                        cutText: text,
                        limit: false,
                        fSize: this.getFontSize( true, text ),
                        ppfSize: this.getFontSize( false, text )
                    } );

                }
            }
        }catch ( e ){
            console.warn(e);
        }
    };


    getWidthOfText = ( txt, fontname ) => {
        let canvas = document.createElement( 'canvas' );
        let ctx = canvas.getContext( '2d' );
        ctx.font = fontname;// "30px Arial";
        let len = ctx.measureText( txt ).width;
        canvas.remove();
        return len;
    };

    popupClose = () => {
        this.setState( { showText: false } );
    };

    onResize = () => {
        if ( ( this.props.text !== '' ) || ( this.props.text !== null ) ) {
            this.setText( this.props );
        }
    };

    render() {
        const { textClass, popupTextClass, visibleIcon, text, contentColor, content, customfontFamily, customfontWeight, textStyle = {} } = this.props;

        let marginValue;
        let elmWidth = window.innerWidth;
        if ( elmWidth < 420 && this.state.type === 'calendar' && this.state.limit ) {
            marginValue = this.getFontSize( true, text );
        } else {
            marginValue = '0';
        }


        return (
            <div
                ref={ ( elm ) => {
                    this.resizeElm = elm;
                } }
                style={ { marginTop: marginValue } }
                className={ this.props.cutTextClass ? this.props.cutTextClass : styles.wrapText }>
                { visibleIcon && this.state.limit &&
                <InfoIcon  style={ { fill: contentColor.dark } } onClick={ () => {
                    this.setState( { showText: !this.state.showText } );
                } } className={ styles.infoIcon }/> }

                <p onClick={ this.state.limit ? () => {
                    this.setState( { showText: !this.state.showText } );
                } : null }
                   ref={ ( p ) => {
                       this.elmP = p;
                   } }
                   className={ textClass }

                   style={ {
                       fontSize: this.state.fSize,
                       padding: '0.7rem',
                       fontFamily: customfontFamily,
                       fontWeight: customfontWeight,
                       color: this.props.fColor ? this.props.fColor : '#fff'
                   } }>
                    <span className={ styles.more }
                          style={ {...textStyle } }
                          dangerouslySetInnerHTML={ { __html: wrapUrlByTag( this.state.cutText ) } }/>
                    { this.state.limit &&
                    <span className={ styles.more }     style={ {...textStyle } } onClick={ () => {
                        this.setState( { showText: !this.state.showText } );
                    } }>
              { visibleIcon ?
                  <b style={ { paddingLeft: '1rem' } }>{ content.popup.read_more }</b> :
                  <span>...</span>
              }
              </span> }
                </p>

                { this.state.showText &&
                <article style={ visibleIcon && { backgroundColor: contentColor.overlay } }
                         className={ this.props.popupClass ? this.props.popupClass : styles.popup }>
                    <svg onClick={ this.popupClose }
                         xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'
                         className={ styles.closePopup }>
                        <circle cx='119' cy='121' r='106' fill='#FFF'></circle>
                        <path
                            d='M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z'></path>
                    </svg>

                    <Scrollbars
                        className={ styles.scroll }
                        autoHide={ true }
                        autoHideTimeout={ 1000 }
                        autoHideDuration={ 200 }
                        thumbMinSize={ 30 }
                        universal={ true }
                        style={ { height: '20rem', width: '100%', marginTop: '2rem' } }
                        renderTrackHorizontal={ props => <div { ...props } className={ styles.trackHorizontal }/> }
                        renderTrackVertical={ props => <div { ...props } className={ styles.trackVertical }/> }
                        renderThumbHorizontal={ props => <div { ...props } className={ styles.thumbHorizontal }/> }
                        renderThumbVertical={ props => <div { ...props } className={ styles.thumbVertical }/> }
                        renderView={ props => <div { ...props } style={ {
                            marginBottom: '-20px',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            overflow: 'scroll',
                            marginRight: '-11px'
                        } }/> }>

                        <p
                            style={
                                visibleIcon ? { color: contentColor.dark, fontSize: this.state.ppfSize, ...textStyle } :
                                    { fontSize: this.state.ppfSize, ...textStyle } }
                            className={ popupTextClass }>
                            { this.state.text }
                        </p>
                    </Scrollbars>
                </article> }
            </div>
        );
    };
}

export default CutText;


